module.exports = __webpack_public_path__ + "img/graduate-account.55b1613.svg";